import { useContext, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import RoutesApp from "./routes/routes";
import CssBaseline from "@mui/material/CssBaseline";
import "./index.css";
import { AuthProvider } from "./contexts/AuthContext";
import { GlobalAlertProvider } from "./contexts/GlobalAlertContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { LangProvider } from "./contexts/LangContext";
import React from "react";

function App() {
  return (
    <>
      <BrowserRouter>
        <LangProvider>
          <ThemeProvider>
            <GlobalAlertProvider>
              <AuthProvider>

                <CssBaseline />
                <RoutesApp />

              </AuthProvider>
            </GlobalAlertProvider>
          </ThemeProvider>
        </LangProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
